'use strict';

wbApp.factory('previewHoursSvc', ['$resource', '$translate', '$q', 'notificationSvc', 'repositorySvc',
    function ($resource, $translate, $q, notificationSvc, repositorySvc) {

        var PreviewHour = $resource('/Api/PreviewHours/Get', {}, {
            'query': { method: 'GET', isArray: true },
            'insert': { method: 'POST', url: '/Api/PreviewHours/Insert' },
            'update': { method: 'POST', url: '/Api/PreviewHours/Update' },
            'delete': { method: 'POST', url: '/Api/PreviewHours/Delete' },
            'register': { method: 'POST', url: '/Api/PreviewHours/Register' },
            'excuse': { method: 'POST', url: '/Api/PreviewHours/Excuse' },
            'rebook': { method: 'POST', url: '/Api/PreviewHours/ReBook' },
            'getPreviewHoursSuccessStats': { method: 'GET', isArray: true, url: '/Api/PreviewHours/GetPreviewHoursSuccessStats' },
        });

        var previewHours;
        var forSemesterID;

        function getPreviewHoursSuccessStats(fromDate, toDate)
        {
            return repositorySvc.customGet(
                    'getPreviewHoursSuccessStats',
                    PreviewHour,
                    {
                        fromDate: fromDate,
                        toDate: toDate
                    });
        }

        function getPreviewHoursSuccessGraph(data)
        {
            var cols = [
                { id: 'r', label: $translate.instant("TXT_LBL_REFERENCE"), type: 'string' },
                { id: 'p', label: $translate.instant('TXT_PREVIEW_HOURS'), type: 'number' },
                { id: 's', label: $translate.instant('TXT_SAME_SEMESTER'), type: 'number' },
                { id: 'a', label: $translate.instant('TXT_ANY_TIME'), type: 'number' }
            ];
            var rows = [];

            _.forEach(data, function (d) {
                rows.push({
                    c: [
                        { v: d.reference },
                        { v: d.noOfPreviewHours },
                        { v: d.noOfRegistrationsInTheSameSemester },
                        { v: d.noOfRegistrationsInAnySemester }
                    ]
                })
            });

            return {
                cols: cols,
                rows: rows
            };

        }

        function getAll(semesterID, refresh) {
            if (!previewHours || forSemesterID != semesterID || refresh) {
                previewHours = repositorySvc.get(PreviewHour, { semesterID: semesterID });
                forSemesterID = semesterID;
            }
            return previewHours;
        }

        function getAllForClassroomAsync(semesterID, classroomID, refresh) {
            if (!classroomID) {
                return getAll(semesterID, refresh);
            }

            var deferred = $q.defer();
            var m = [];
            m.$promise = deferred.promise;

            getAll(semesterID, refresh).$promise
                .then(function (data) {
                    for (var i = 0; i < data.length; i++) {
                        var d = data[i];
                        if (d.classroomID === classroomID) {
                            m.push(d);
                        }
                    }

                    deferred.resolve(m);
                });

            return m;
        }

        function insert(data, successCallback, errorCallback) {
            var p;
            if (forSemesterID != data.semesterID) {
                p = [];
            } else {
                if (!previewHours) {
                    previewHours = [];
                }
                p = previewHours;
            }

            repositorySvc.insert(
                PreviewHour,      // $resource
                p,                // collection
                data,             // entity
                successCallback,
                errorCallback);
        }

        function update(data, successCallback, errorCallback) {
            repositorySvc.update(
                PreviewHour,      // $resource
                previewHours,     // collection
                data,             // entity
                successCallback,
                errorCallback);
        }

        function remove(data, errorCallback) {
            repositorySvc.remove(
                PreviewHour,      // $resource
                previewHours,     // collection
                data,             // entity
                null,             // successCallback
                errorCallback,
                { studentID: data.studentID, courseScheduleID: data.courseScheduleID });
        }

        function registerOnCourse(data, successCallback, errorCallback) {
            PreviewHour.register(data, function (successResult) {
                if (!!successCallback) {
                    repositorySvc.entityUpdated(previewHours, successResult);
                    successCallback(successResult);
                    notificationSvc.notifyInfo(
                        $translate.instant('TXT_ALERT_TITLE_COURSE_REGISTRATION_SUCCESS'));
                }
            },
            function (errorResult) {
                if (!!errorCallback) {
                    errorCallback(errorResult.data);
                } else {
                    notificationSvc.notifyError(
                        $translate.instant('TXT_ALERT_TITLE_COURSE_REGISTRATION_FAILURE'),
                        notificationSvc.translateError(errorResult.data));
                }
            });
        }

        function excuseFromLesson(data, successCallback, errorCallback) {

            PreviewHour.excuse(data, success, error);

            function success(successResult) {
                repositorySvc.entityUpdated(previewHours, successResult);
                if (!!successCallback) {
                    successCallback(successResult);
                }
                notificationSvc.notifyInfo(
                    $translate.instant('TXT_ALERT_TITLE_ATTENDANCE_EXCUSE_SUCCESS'));
            }

            function error(errorResult) {
                if (!!errorCallback) {
                    errorCallback(errorResult.data);
                } else {
                    notificationSvc.notifyError(
                        $translate.instant('TXT_ALERT_TITLE_ATTENDANCE_EXCUSE_FAILURE'),
                        notificationSvc.translateError(errorResult.data));
                }
            }
        }

        function bookOnLessonAgain(data, successCallback, errorCallback) {

            PreviewHour.rebook(data, success, error);

            function success(successResult) {
                repositorySvc.entityUpdated(previewHours, successResult);
                if (!!successCallback) {
                    successCallback(successResult);
                }
                notificationSvc.notifyInfo(
                    $translate.instant('TXT_ALERT_TITLE_ATTENDANCE_BOOK_AGAIN_SUCCESS'));
            }

            function error(errorResult) {
                if (!!errorCallback) {
                    errorCallback(errorResult.data);
                } else {
                    notificationSvc.notifyError(
                        $translate.instant('TXT_ALERT_TITLE_ATTENDANCE_BOOK_AGAIN_FAILURE'),
                        notificationSvc.translateError(errorResult.data));
                }
            }
        }

        return {
            getAll: getAll,
            getAllForClassroomAsync: getAllForClassroomAsync,
            insert: insert,
            update: update,
            remove: remove,
            registerOnCourse: registerOnCourse,
            excuseFromLesson: excuseFromLesson,
            bookOnLessonAgain: bookOnLessonAgain,
            getPreviewHoursSuccessStats: getPreviewHoursSuccessStats,
            getPreviewHoursSuccessGraph: getPreviewHoursSuccessGraph
        }
    }]);